import toCurrency from "@/helpers/toCurrency";

const addressFormatter = location => {
  const addr = location.address;
  let address;

  if (addr.street) address = addr.street;

  if (addr.number) address = `${address}, ${addr.number}`;

  if (addr.number) address = `${address}, ${addr.neighborhood}`;

  if (addr.number) address = `${address} - ${addr.city}`;

  if (addr.number) address = `${address}/${addr.state}`;

  return address;
};

const deliveryFee = order => {
  let result;

  if (order.deliveryFee) result = toCurrency(order.deliveryFee);
  else result = "Grátis";

  return result;
};

export { addressFormatter, deliveryFee };
